














































import {
  Vue,
  Component
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { useEnrollmentStore } from "@/employee/store/enrollment";

@Component({
  components: {}
})
export default class SelfReportedEmployeeUnclaimed extends Vue {
  $validator: Validator;
  employerName = "";
  isSubmitting = false;
  didSubmit = false;

  enrollmentStore = useEnrollmentStore();

  onSubmit () {
    this.isSubmitting = true;
    this.$validator
        .validateAll()
        .then(result => {
          if (result) {
            return this.enrollmentStore.putUserEmployerName(this.employerName)
                .then(_ => {
                  this.didSubmit = true;
                  return Promise.resolve();
                });
          }

          return Promise.resolve();
        })
        .finally(() => {
          this.isSubmitting = false;
        });
  }

}
